/* Publish by EComposer at 2026-10-31 21:01:59*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-v24cl7rnxy"]=  window.__ectimmers["ecom-v24cl7rnxy"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-v24cl7rnxy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v24cl7rnxy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z2h3tuhz3ek').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z2h3tuhz3ek', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tdfpcmp6hcq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tdfpcmp6hcq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-93yek5pwhyj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-93yek5pwhyj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tfj848512q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tfj848512q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8pwcfkfy7hf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8pwcfkfy7hf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rjkuctimbfq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rjkuctimbfq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-78k4qyrfsir').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-78k4qyrfsir', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xsxw9m1pexb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xsxw9m1pexb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hhopibr0z9p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hhopibr0z9p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-chbjgdcuc5n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-chbjgdcuc5n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-apes91c6kg9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-apes91c6kg9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-shueb2vipg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-shueb2vipg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0yqbldja3qxk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0yqbldja3qxk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5g721j4uhjh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5g721j4uhjh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cmswccchsn7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cmswccchsn7', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-wuhxhg054id"]=  window.__ectimmers["ecom-wuhxhg054id"] || {};
let t=this.$el;if(!t)return;let e=t.querySelectorAll(":scope > .tabs__wrapper > div > .tabs__navs > .tabs__navs--items > .tabs__nav"),i=t.querySelectorAll(":scope > .tabs__wrapper > .core__group--items > .tab__item"),s=this.settings.action;function o(a,l){a.classList.contains("ecom-item-active")||(e.forEach(c=>c.classList.remove("ecom-item-active")),i.forEach(c=>c.classList.remove("ecom-item-active")),a.classList.add("ecom-item-active"),i[l].classList.add("ecom-item-active"),setTimeout(()=>{const c=i[l];c&&c.querySelectorAll(".ec_splide").forEach(d=>{var p;(p=d.ec_splide)==null||p.refresh()})},50),r())}e.forEach((a,l)=>{s==="click"||window.screen.width<1025?a.onclick=()=>o(a,l):a.onmouseover=()=>o(a,l)});function n(){let a=window.location.hash;if(a){let l=t.querySelector(`[data-target="${a}"]`);if(l){l.click();let c=new MouseEvent("mouseover",{bubbles:!0,cancelable:!0,view:window});l.dispatchEvent(c);let m=l.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;window.scrollTo(0,m)}}}setTimeout(()=>{n()},300);function r(){setTimeout(()=>{const a=t.querySelector(".tab__item.ecom-item-active");a&&a.querySelectorAll(".ec_splide").forEach(l=>{var c;(c=l.ec_splide)==null||c.refresh()}),window.dispatchEvent(new window.Event("resize"))},100)}window.addEventListener("hashchange",n,!1)

                    });
                    
                        document.querySelectorAll('.ecom-wuhxhg054id').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wuhxhg054id', settings: {"action":"click"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-y0zg51raxh"]=  window.__ectimmers["ecom-y0zg51raxh"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-y0zg51raxh"]["d3w2t7ct3"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-y0zg51raxh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y0zg51raxh', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9hc1u9982s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9hc1u9982s', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-axoxcm4l8wq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-axoxcm4l8wq', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1xn58xf0lo2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1xn58xf0lo2', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}